import { render, staticRenderFns } from "./statisticalCustomer.vue?vue&type=template&id=795144d2&scoped=true"
import script from "./statisticalCustomer.vue?vue&type=script&lang=js"
export * from "./statisticalCustomer.vue?vue&type=script&lang=js"
import style0 from "./statisticalCustomer.vue?vue&type=style&index=0&id=795144d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795144d2",
  null
  
)

export default component.exports